import React, { useCallback } from 'react';

import Filter, { SelectedFilters } from '../../types/Filter/Filter';
import Select from '../Select/Select';

import styles from './FiltersHeader.module.scss';

interface FiltersHeaderProps {
    filters: Filter[];
    selectedFilters: SelectedFilters;
    onFiltersChange: (selectedFilters: SelectedFilters) => void;
}

const FiltersHeader = ({
    filters,
    selectedFilters,
    onFiltersChange,
}: FiltersHeaderProps) => {
    const handleFiltersChange = useCallback(
        (key: string, value: string | number | null) => {
            onFiltersChange({
                ...selectedFilters,
                [key]: value,
            });
        },
        [selectedFilters, onFiltersChange]
    );

    return (
        <div className={styles.root} data-cy="filters-header">
            {filters.map((filter) => (
                <Select
                    label={filter.displayName}
                    key={filter.key}
                    options={filter.options}
                    onChange={(value) => handleFiltersChange(filter.key, value)}
                    value={selectedFilters[filter.key]}
                />
            ))}
        </div>
    );
};

export default FiltersHeader;
